import React, { } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button, makeStyles } from '@material-ui/core';
import bin from '../assets/icons/primary-blue-bin.png';
import { baseApiUrl } from '../dataProvider/sails';
import { useSelector } from 'react-redux';
import { InsertDriveFile } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    container: {
        margin: theme.spacing(2),
        backgroundColor: '#ffffff',
        padding: theme.spacing(1),
        alignItems: 'center',
        display: 'flex'
    },
    Icon: {
        width: 14,
        height: 14
    },
    btnAdd: {
        padding: 5,
        minWidth: 'unset',
        width: 25,
        height: 25,
        backgroundColor: '#ffffff',
        borderRadius: 10,
        border: 'solid 2px #e5f1f8;',
    },
    NameImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '13.2px',
        letterSpacing: '0.13px',
        color: '#4f5064',
        maxWidth: 250,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    SizeImage: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '13.2px',
        letterSpacing: 'normal',
        color: '#88898c',
    },
    thumbnail: {
        width: 'auto',
        height: 44,
    }
}));

function ThumbnailIcon({ thumbnail, onClear, isImage }) {
    const classes = useStyles();
    const { fd, name, size } = thumbnail || {};
    const { isEditing } = useSelector(state => state.tree);

    if (!thumbnail) return null;
    return (
        <Box className={classes.container}>
            <Box flex={2} >
                {
                    isImage ? (
                        <img
                            src={baseApiUrl + "/media/" + fd}
                            className={classes.thumbnail}
                            alt="thumbnail"
                        />
                    ) : <InsertDriveFile fontSize="large" style={{ color: '#88898c' }} />
                }
            </Box>
            <Box flex={6} >
                <Typography className={classes.NameImage} >{name}</Typography>
            </Box>
            <Box flex={2} >
                <Typography className={classes.SizeImage} >{Math.ceil(size / 1000000)} mb</Typography>
            </Box>
            <Box flex={1}>
                <Button disabled={!isEditing} className={classes.btnAdd} onClick={onClear}>
                    <img alt='delete thumbnail' src={bin} className={classes.Icon} />
                </Button>
            </Box>
        </Box>
    );
}

ThumbnailIcon.propTypes = {
    thumbnail: PropTypes.shape({
        fd: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        size: PropTypes.number.isRequired,
    }),
    onClear: PropTypes.func.isRequired,
    isImage: PropTypes.bool,
};

export default ThumbnailIcon;
